<template>
	<div class="c-project-list-container">
		<c-loader class="c-project-list" v-if="isLoading" />
		<section class="c-project-list" v-else>
			<ul class="c-project-list__list" v-bind:class="{ padded: padded }">
				<li v-for="(project, index) in projects"
					:class="index <= 2 ? 'c-project-list__item c-project-list__item--featured' : 'c-project-list__item'">

	 				<router-link
						class="c-project-list__link"
						:key="project.slug"
						:to="settings.currentLang === 'en-us' ? '/en/work/' + project.slug : '/work/' + project.slug"
						:style="'background-image:url(' + project.featuredImageUrl + ')'">

						<div
							class="c-project-list__link__skewy"
							:style="'transform: translateY(50%) skewY(' + randomSkew() + 'deg);'"
							v-if="index <= 2">
						</div>
						<img class="c-project-list__image" :src="project.featuredImageUrl" :alt="project.featuredImageAlt">

						<div class="c-project-list__link__content">
							<h3 class="c-project-list__title" v-html="project.title"></h3>
							<p class="c-project-list__client">{{ project.client }}</p>
						</div>
					</router-link>
				</li>
			</ul>
		</section>
	</div>
</template>

<script>
import CLoader from '@/components/Loader'

export default {
	name: 'project-list',
	components: {
		CLoader
	},
	props: ['ids', 'featured', 'padded', 'loading', 'filter'],
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		isLoading() {
			if (typeof this.loading === 'boolean') {
				return this.loading
			}
			return this.$store.state.projects.loading
		},
		projects() {
			if (this.ids) {
				return this.$store.getters.getProjectsByIds({ ids: this.ids, lang: this.settings.currentLang })
			} else if (this.featured) {
					return this.$store.getters.getFeaturedProjects({ lang: this.settings.currentLang })
			} else {
				return this.$store.state.projects.projectsList[this.settings.currentLang]
			}
		}
	},
	watch: {
		ids: function() {
			this.fetchProjectsData();
		},
		'$route': function() {
			this.fetchProjectsData();
		}
	},
	beforeMount() {
		this.fetchProjectsData();
	},
	methods: {
		fetchProjectsData() {
			this.$store.dispatch('loadProjects', { lang: this.settings.currentLang, filter: this.filter })
		},
		randomSkew() {
			let r = Math.round((Math.random() * 16) - 8);
			if(r < 1 && r > 0) r += 2;
			if(r > -1 && r < 0) r -= 2;
			return r;
		}
	}
};
</script>

<style lang="scss">

@import "../assets/css/helpers";

$m: 'c-project-list';

.page-work {
	.#{$m}__item--featured {
		@include mq($from: medium) {
			width: 100% !important;
			margin-bottom: 2rem;
			position: relative;

			.c-project-list__link {
				overflow: hidden;

				&::before {
					background: $colorBrandSecondary;
					opacity: .3;
				}
				&::after {
					display: none;
				}
				&__skewy {
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-image: linear-gradient(-180deg, rgba($colorBrandMain, 1) 0%, rgba($colorBrandMain, .5) 100%);
					// background: $colorBrandMain;
					opacity: .4;
					transition: 1.5s transform $easeOutQuint, 1s opacity $easeOutQuint;
				}

				&:hover {
					&::before {
						opacity: .8;
					}
					.c-project-list__link__skewy {
						opacity: .6;
						transform: translateY(50%) skewY(0) !important;
					}
				}
			}
			.c-project-list__link__content {
				bottom: auto;
				top: 50%;
				transform: translateY(-50%);
			}
			.c-project-list__title {
				font-size: 2.5rem;
				margin-bottom: .75rem;
			}
			.c-project-list__client {
				font-size: 1.25rem;
			}
		}
	}
}

.#{$m} {
	max-width: 1600px;
	margin: 0 auto;

	&-container {
		position: relative;
		min-height: 200px; // optical – make sure loader is visible
	}

	&__list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	&__item {
		display: block;
		width: 100%;
		position: relative;
		// margin-bottom: 1.5rem;

		.padded & {
			margin-bottom: .5rem;
		}
		@include mq($from: medium) {
			width: 50%;
			margin-bottom: 0;

			.padded & {
				width: 49%;
				margin-bottom: 2rem;
			}
		}
	}
	&__link {
		display: block;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		height: 0;
		padding-bottom: 56.25%;
		position: relative;


		&::after, &::before {
			content: "";
			display: block;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
		}
		&::before {
			height: 100%;
			background-color: $colorBrandMain;
			mix-blend-mode: multiply;
			opacity: 0;
			transition: .5s opacity;
		}
		&::after {
			height: 90%;
			background-image: linear-gradient(-180deg, rgba($colorBrandSecondary, 0) 3%, rgba($colorBrandSecondary, 1) 100%);
			opacity: .7;
			transition: .5s opacity;
		}

		&__content {
			position: absolute;
			bottom: 2rem;
			left: 0;
			width: 100%;
			color: #fff;
			text-align: center;
			z-index: 1;
		}

		&:hover {
			&::after {
				opacity: 1;
			}
			&::before {
				opacity: .4;
			}
			.#{$m}__title {
				// color: $colorBrandMain;
			}
		}
	}
	&__title {
		font-size: 1.75rem;
		font-weight: 600;
		line-height: 1;
		margin-bottom: .5rem;
		transition: .5s color;
		padding: 0 .5rem;
	}
	&__client {
		line-height: 1;
		font-family: $fontFamilyBase;
	}

	&__image {
		display: none;
	}
}

</style>



// WEBPACK FOOTER //
// ProjectList.vue?4ef115c2